import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AssetManagementState } from './asset-management.reducer';

export const selectAssetManagementState =
  createFeatureSelector<AssetManagementState>('assetManagementReducer');

export const selectNetworks = createSelector(
  selectAssetManagementState,
  state => state.networks
);

export const selectNetworksLoading = createSelector(
  selectAssetManagementState,
  state => state.networksLoading
);

export const selectNetworksError = createSelector(
  selectAssetManagementState,
  state => state.networksError
);

export const selectAssetNetworks = createSelector(
  selectAssetManagementState,
  state => state.assetNetworks
);

export const selectAssetNetworksLoading = createSelector(
  selectAssetManagementState,
  state => state.assetNetworksLoading
);

export const selectAssetNetworksError = createSelector(
  selectAssetManagementState,
  state => state.assetNetworksError
);

export const selectWhitelistAddresses = createSelector(
  selectAssetManagementState,
  state => state.whitelistAddresses
);

export const selectWhitelistAddressesLoading = createSelector(
  selectAssetManagementState,
  state => state.whitelistAddressesLoading
);

export const selectWhitelistAddressesError = createSelector(
  selectAssetManagementState,
  state => state.whitelistAddressesError
);

export const selectWhitelistAddressesPagination = createSelector(
  selectAssetManagementState,
  state => state.whitelistAddressesPagination
);

export const selectWhitelistAddressesSort = createSelector(
  selectAssetManagementState,
  state => state.whitelistAddressesSort
);

export const selectWhitelistAddressesSearchTerm = createSelector(
  selectAssetManagementState,
  state => state.whitelistAddressesSearchTerm
);

export const selectWhitelistAddressesMinimal = createSelector(
  selectAssetManagementState,
  state => state.whitelistAddressesMinimal
);

export const selectWhitelistAddressesMinimalLoading = createSelector(
  selectAssetManagementState,
  state => state.whitelistAddressesMinimalLoading
);

export const selectWhitelistAddressesMinimalError = createSelector(
  selectAssetManagementState,
  state => state.whitelistAddressesMinimalError
);

// Balance History Selectors
export const selectBalanceHistory = createSelector(
  selectAssetManagementState,
  state => state.balanceHistory
);

export const selectBalanceHistoryLoading = createSelector(
  selectAssetManagementState,
  state => state.balanceHistoryLoading
);

export const selectBalanceHistoryError = createSelector(
  selectAssetManagementState,
  state => state.balanceHistoryError
);
